// extracted by mini-css-extract-plugin
module.exports = {"subject-tag":"SubjectTag_subject-tag__3ALh_","link":"SubjectTag_link__viSGd","hidden":"SubjectTag_hidden__3Bs8V"};